<template>
  <div class="campaign-linker">
    <TheHeader
      v-bind="{
        currentUser,
        spaces,
        currentSpace,
        createSpace,
        logout,
        selectSpace,
        isAdmin,
        isSpaceRoute,
        isSuperAdminRoute,
        isSuperAdmin,
      }"
    />
    <v-content>
      <transition name="top-level" mode="out-in">
        <router-view />
      </transition>
    </v-content>
  </div>
</template>

<script>
import store from "@/store";
import { mapGetters, mapState } from "vuex";
import TheHeader from "@/components/TheHeader";

export default {
  components: {
    TheHeader,
  },
  computed: {
    ...mapGetters(["isSignedIn", "currentUser", "isAdmin", "isSuperAdmin"]),
    ...mapGetters("spaces", { currentSpace: "active" }),
    ...mapState("spaces", { spaces: "content" }),
  },
  watch: {
    $route() {
      this.isSpaceRoute = this.checkForSpaceRoute();
      this.isSuperAdminRoute = this.checkForSuperAdminRoute();
    },
    isSignedIn() {
      this.$router.push("/");
    },
  },
  created() {
    !this.currentSpace && this.$router.push("/spaces/");
    this.$store.dispatch("spaces/findAll");
    this.$store.dispatch("admins/open", {}, { root: true });
    this.isSpaceRoute = this.checkForSpaceRoute();
    this.isSuperAdminRoute = this.checkForSuperAdminRoute();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch("fetchCurrentUser");
    if (store.getters.isSignedIn) {
      next();
    } else {
      store.dispatch("logout");
      next("/");
    }
  },
  methods: {
    async createSpace(name) {
      await this.$store.dispatch("spaces/save", {
        name,
        query: {
          default: true,
        },
      });
      this.currentSpace && this.$store.commit("addSpace", this.currentSpace.id);
      this.selectSpace(this.currentSpace.id);
    },
    selectSpace(id) {
      const space_id = id.toString();
      this.$router.push({ name: "campaigns", params: { space_id } });
    },
    logout() {
      this.$store.dispatch("logout");
    },
    checkForSpaceRoute() {
      var regex = new RegExp("/spaces/?$");
      if (!this.$router.currentRoute) return;
      var path = this.$router.currentRoute.path
        ? this.$router.currentRoute.path
        : "";
      return !regex.test(path);
    },
    checkForSuperAdminRoute() {
      var regex = new RegExp("/admin/?$");
      if (!this.$router.currentRoute) return;
      var path = this.$router.currentRoute.path
        ? this.$router.currentRoute.path
        : "";
      return regex.test(path);
    },
  },
};
</script>

<style lang="scss">
.campaign-linker {
  width: 100%;
  max-width: $max-app-width;
  margin: 0 auto;

  .v-content {
    margin-bottom: 20px;
  }
}
.v-toolbar__content,
.v-toolbar__extension {
  max-width: $max-app-width;
  margin: 0 auto;
}
</style>
